import { FleetVehicle, validPosition } from "./fleetData";

// Visual interpolation between measured fixes; these positions are not history.
export function interpolateFleet(from: FleetVehicle[], to: FleetVehicle[], progress: number): FleetVehicle[] {
  const previous = new Map(from.map(vehicle => [vehicle.id,vehicle]));
  const t = Math.max(0,Math.min(1,progress));
  if(t===1) return to;
  const eased = t*t*(3-2*t);
  return to.map(vehicle => {
    const before = previous.get(vehicle.id);
    const start = validPosition(before?.lat,before?.lng), end = validPosition(vehicle.lat,vehicle.lng);
    if(!before || before.unreachable || vehicle.unreachable || !start || !end) return vehicle;
    // A large discontinuity is a new fix, not evidence of a driven path.
    if(Math.abs(end.lat-start.lat)>.02 || Math.abs(end.lng-start.lng)>.02) return vehicle;
    return {...vehicle,lat:start.lat+(end.lat-start.lat)*eased,lng:start.lng+(end.lng-start.lng)*eased};
  });
}
